import { createFileRoute } from "@tanstack/react-router";
import { PoliciesController } from "@/features/policies";
import { admitPolicyDirectory } from "@/features/policies/records";
import { VerifiedViewer } from "@/session/product-session";

export const Route = createFileRoute("/_site/policies/")({
  loader: ({ location, abortController }) => {
    const search = new URLSearchParams(location.searchStr);
    return admitPolicyDirectory({
      data: { q: search.get("q") ?? "", cursor: search.get("cursor") },
      signal: abortController.signal,
    });
  },
  component: PoliciesPage,
});

function PoliciesPage() {
  const policyDirectoryViewer = Route.useLoaderData();
  return (
    <VerifiedViewer viewer={policyDirectoryViewer}>
      <PoliciesController />
    </VerifiedViewer>
  );
}
